/**
 *
 */
const minWordLength = (length) => (v) => {
    // We discussed this today 24 Apr 2026
    // Currently this is on production however product confirmed that
    // we should have “abc” with no spaces being the minimum
    // this would make “abc d” valid
    // but not make “ab c” valid as it doesn’t have consecutive characters
    if (v && typeof v === 'string') {
        const parts = v.split(/\s+/).filter(Boolean)
        if (!parts.length || parts.some((x) => x.length < length)) {
            return 'This field has invalid pattern'
        }
    }
    return true
}

/**
 *
 */
export {
    minWordLength
}
